import coreStore from './core-store'

const remoteResource = 'operation/api/v1/operation-definitions';


const operationDefinitionStore = coreStore.createCoreStore('operationDefinition', remoteResource);


operationDefinitionStore.getters.operationDefinition = (state) => (id) => {
    const definition = state['operationDefinitions'].find(definition => definition.id === id);
    return definition ?? {name: "N/A", model: {dynaProperties: []}};

}


export default operationDefinitionStore;

// export default {
//     namespaced: true,
//     state: {
//         operationDefinitions: [],
//     },
//     getters: {
//         operationDefinitions: (state) => {
//             return state.operationDefinitions;
//         },
//         operationDefinition: (state) => (id) => {
//             let operationDefinition = state.operationDefinitions.filter(acc => acc.id == id);
//             return operationDefinition.length != 0 ? operationDefinition[0] : null;
//         }
//     },
//     mutations: {
//         addOperationDefinition(state, {operationDefinition}) {
//             state.operationDefinitions.push(operationDefinition);
//         },
//         clearOperationDefinitions(state) {
//             state.operationDefinitions = [];
//         }
//     },
//     actions: {
//         refreshOperationDefinitions({commit}) {
//             commit('clearOperationDefinitions');
//             return fetch("operation/api/v1/operation-definitions")
//                 .then(res => res.json())
//                 .then(res => {
//                     res.forEach(def => commit("addOperationDefinition", { operationDefinition: def }));
//                 })
//         }
//     }
// }
